import React from 'react';

const SearchBox = ({ searchChange, Click }) => {
	return (
		<div className='pa2'>
			<div>
				<input
					className='f6 grow no-underline br-pill ph3 pv2 mb2 dib black bg-light-blue' 
					type='search' 
					placeholder='mm/dd/'
					minLength="6"
					maxLength="6" 
					onInput={searchChange}
				/>
			</div>
			<div>
				<input 
					className='f6 grow no-underline br-pill ph3 pv2 mb2 dib black bg-light-blue' 
					type='button' 
					value='random' 
					onClick={Click}
				/>
			</div>
		</div>
	);
}

export default SearchBox;